import { useState, useEffect, useCallback } from 'react';

interface UseSubsectionSettingsProps {
  subsection: PolicyFormSubSection;
  questions: Record<string, PolicyFormQuestion>;
  onSave: (updates: Partial<PolicyFormSubSection>) => void;
  onClose: () => void;
}

function isConditionMeaningful(condition?: Condition): boolean {
  if (!condition) return false;
  if ('conditions' in condition) return condition.conditions.length > 0;
  return !!condition.field;
}

export function useSubsectionSettings({ subsection, onSave, onClose }: UseSubsectionSettingsProps) {
  const [title, setTitle] = useState(subsection.title);
  const [hasCondition, setHasCondition] = useState(!!subsection.conditional?.visible);
  const [condition, setCondition] = useState<Condition | undefined>(
    subsection.conditional?.visible,
  );

  useEffect(() => {
    setTitle(subsection.title);
    setHasCondition(!!subsection.conditional?.visible);
    setCondition(subsection.conditional?.visible);
  }, [subsection]);

  const handleSave = useCallback(() => {
    const conditional: ConditionalBehavior | undefined =
      hasCondition && isConditionMeaningful(condition) ? { visible: condition } : undefined;

    onSave({ title, conditional });
    onClose();
  }, [hasCondition, condition, title, onSave, onClose]);

  return {
    title,
    setTitle,
    hasCondition,
    setHasCondition,
    condition,
    setCondition,
    handleSave,
  };
}
